import { error } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const ChangeEmailResendLink = gql`
  mutation ChangeEmailResendLink {
    changeEmailResendLink {
      ... on ChangeEmailResendLinkSuccess {
        success
        __typename
      }
      ... on ChangeEmailTooManyAttempts {
        ...error
        __typename
      }
      ... on ChangeEmailError {
        ...error
        __typename
      }
    }
  }
  ${error}
`;

export default ChangeEmailResendLink;
